import type { AxiosInstance } from 'axios';
import { apiClient } from '../client/client';
import type { ServiceResultT } from '../types/common/ServiceResultT';
import type {
  AnalyticsJourneyRow,
  AnalyticsOverviewViewModel,
  AnalyticsPagePerformanceRow,
  AnalyticsQueryFilter,
  AnalyticsSessionDetailViewModel,
  AnalyticsSessionSummaryRow,
} from '../types/analytics';

export class AnalyticsAdminService {
  private static readonly BASE = '/api/Admin/Analytics';

  constructor(private readonly client: AxiosInstance = apiClient) {}

  async getOverview(filter: AnalyticsQueryFilter): Promise<AnalyticsOverviewViewModel> {
    const { data } = await this.client.get<ServiceResultT<AnalyticsOverviewViewModel>>(
      `${AnalyticsAdminService.BASE}/overview`,
      { params: filter },
    );
    if (!data?.data) throw new Error(data?.message ?? 'Analitik özeti alınamadı.');
    return data.data;
  }

  async getPages(filter: AnalyticsQueryFilter): Promise<AnalyticsPagePerformanceRow[]> {
    const { data } = await this.client.get<ServiceResultT<AnalyticsPagePerformanceRow[]>>(
      `${AnalyticsAdminService.BASE}/pages`,
      { params: filter },
    );
    return data?.data ?? [];
  }

  async getJourneys(filter: AnalyticsQueryFilter): Promise<AnalyticsJourneyRow[]> {
    const { data } = await this.client.get<ServiceResultT<AnalyticsJourneyRow[]>>(
      `${AnalyticsAdminService.BASE}/journeys`,
      { params: filter },
    );
    return data?.data ?? [];
  }

  async getSessions(
    filter: AnalyticsQueryFilter,
  ): Promise<{ items: AnalyticsSessionSummaryRow[]; total: number }> {
    const { data } = await this.client.get<
      ServiceResultT<{ items: AnalyticsSessionSummaryRow[]; total: number }>
    >(`${AnalyticsAdminService.BASE}/sessions`, { params: filter });
    return data?.data ?? { items: [], total: 0 };
  }

  async getSessionDetail(sessionId: string): Promise<AnalyticsSessionDetailViewModel> {
    const { data } = await this.client.get<ServiceResultT<AnalyticsSessionDetailViewModel>>(
      `${AnalyticsAdminService.BASE}/sessions/${sessionId}`,
    );
    if (!data?.data) throw new Error(data?.message ?? 'Oturum detayı alınamadı.');
    return data.data;
  }
}

export const analyticsAdminService = new AnalyticsAdminService();
